import { Client } from "../../bryntum-lib/models/Client";
import { CLIENT_VIEW_COLUMNS } from "./ClientView/clientViewColumnsData.jsx";
import SwivuCellEditor from "../../bryntum-lib/widget/fields/SwivuCellEditor.jsx";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemCopyTo,
  cellMenuItemEditEntity,
  cellMenuItemRemoveRow,
  cellMenuItemSettingsEditor,
  cellMenuItemToggleArchiveRow,
  entityCategorySelector,
  entityStatusSelector,
  entityTagsSelector,
  entityTeamSelector
} from "../utils/gridCellMenuUtils.jsx";
import { generateMultiFilterConfigFromModel } from "../utils/utils.jsx";
import { SWIVU_GROUP_CONTEXT_MENU_SELECTOR } from "./OtherKeys.jsx";
import { gridHeaderMenuProcessItems } from "../utils/otherUtils.jsx";

const CLIENT_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Client),
  tagsValue: { type: '_swivu_settings' },
  categoryValue: { type: '_swivu_settings' },
  statusValue: { type: '_swivu_settings' },
  teamValue: { type: '_swivu_settings' }
}

const CLIENTS_GRID_CONFIG = {
  columns: CLIENT_VIEW_COLUMNS,
  stateId: true,
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll",
    "swivuClientStoreFilter",
    "swivuClientStoreSort",
    "swivuClientStoreGroup"
  ],
  preserveScrollOnDatasetChange: true,
  filterFeature: {
    pickerConfig: {
      fields: CLIENT_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  rowCopyPasteFeature: false,
  regionResizeFeature: true,
  subGridConfigs: {
    locked: {
      weight: 20,
      width: 225
    },
    normal: {
      weight: 30
    }
  },
  cls: "swivu-clients-grid",
  rowReorderFeature: true,
  cellEditFeature: { editorClass: SwivuCellEditor },
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      filterMenu: false,
      removeRow: cellMenuItemRemoveRow(),
      archive: cellMenuItemToggleArchiveRow(),
      editEntity : cellMenuItemEditEntity({ text: "Edit Client" }),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      settingsEditor: cellMenuItemSettingsEditor(),
      entityStatusSelector: entityStatusSelector(),
      entityCategorySelector: entityCategorySelector(),
      entityTagsSelector: entityTagsSelector(),
      entityTeamSelector: entityTeamSelector(),
      copyTo: cellMenuItemCopyTo(),
    },
  },
  headerMenuFeature: {
    processItems: gridHeaderMenuProcessItems("lockedRegion", "normalRegion")
  }
};

export { CLIENTS_GRID_CONFIG };
